/**
 * Card Details Scryfall Link - Shared footer link to Scryfall
 */
import clsx from 'clsx';
import type { ReactElement } from 'react';
import { IoOpenOutline } from 'react-icons/io5';

export interface CardDetailsScryfallLinkProps {
  /** Scryfall set code */
  set: string;
  /** Collector number for the card */
  collectorNumber: string;
  /** Optional extra classes for layout tweaks */
  className?: string;
}

export default function CardDetailsScryfallLink({ set, collectorNumber, className }: CardDetailsScryfallLinkProps): ReactElement {
  return (
    <a
      href={`https://scryfall.com/card/${set}/${collectorNumber}`}
      target="_blank"
      rel="noopener noreferrer"
      className={clsx('text-silver hover:text-pearl flex items-center gap-1.5 text-sm transition-colors', className)}
    >
      View on Scryfall
      <IoOpenOutline className="h-4 w-4" />
    </a>
  );
}
